import { render, staticRenderFns } from "./TelefonosView.vue?vue&type=template&id=d3084a60"
import script from "./TelefonosView.vue?vue&type=script&lang=ts"
export * from "./TelefonosView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports